/**
 * 用户服务：个人资料与余额查询。
 *
 * @module services/user
 */
import type { User } from '@/types';
import { API } from '@/config/api';
import { request } from './http';

/** 余额查询结果。 */
export interface BalanceResult {
  balance: string;
}

/** 更新个人资料入参。 */
export interface UpdateProfileInput {
  name?: string;
}

/** 获取当前用户资料。 */
export async function getProfile(): Promise<User> {
  return request<User>({ method: 'GET', url: API.user.profile });
}

/** 更新个人资料。 */
export async function updateProfile(
  input: UpdateProfileInput,
): Promise<User> {
  return request<User>({ method: 'PATCH', url: API.user.profile, data: input });
}

/** 获取账户余额。 */
export async function getBalance(): Promise<BalanceResult> {
  return request<BalanceResult>({ method: 'GET', url: API.user.balance });
}
